import styled from '@emotion/styled';
export const HeroImage = styled.img `
  width: 100%;
  height: auto;
  object-fit: contain;
  max-height: MIN(calc(100vh - 200px), 110vw);
`;
export const HeroVideo = styled.video `
  width: 100%;
  height: auto;
  object-fit: contain;
  max-height: MIN(calc(100vh - 200px), 110vw);
`;
